export default "__VITE_ASSET__B9ED3O0f__"